import { LOCALES } from 'i18n/locales';

export const assetsHiddenSnackBarIntl = {
    [LOCALES.ENGLISH]: {
        'assetsHidden.alert': 'Some assets are not shown at this zoom level. Please zoom in.',
        'assetsHidden.notification.label': 'Assets hidden'
    },
    [LOCALES.WELSH]: {
        'assetsHidden.alert': 'Nid yw rhai asedau yn cael eu dangos ar y lefel chwyddo hon. Ewch ati i chwyddo i mewn.',
        'assetsHidden.notification.label': 'Asedau wedi\'u cuddio'
    }
};
